<span data-translate="KIND.ANWESENHEITS_SOLL.SUMMARY_MF"
      data-translate-value-tage="{{vm.anwesenheitsSoll.tage || 0}}"
      data-translate-value-halbtage="{{vm.anwesenheitsSoll.halbtage || 0}}"
      data-translate-value-frueh="{{vm.anwesenheitsSoll.fruehbetreuungen || 0}}"
      data-translate-value-mittage="{{vm.anwesenheitsSoll.mittage || 0}}"
      data-translate-value-nachmittage="{{vm.anwesenheitsSoll.halbeNachmittage || 0}}"
      data-translate-interpolation="messageformat">
</span>
